/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';


// Material MUI
import {  
  Button,
  Tooltip,
  Grid,
  Stack,
  Autocomplete,
  TextField,
  IconButton,
  useMediaQuery,
  ListItemAvatar,
  ListItem,
  ListItemText,
  List,
  Avatar,
  Divider,
  CircularProgress,
  Typography
} from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import FmdBadIcon from '@mui/icons-material/FmdBad';

// Services.
import HomeService from '../services/homeService';
import EmpleadoService from '../services/empleadoService';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT } from '../redux/constants/index';

// Components
import msgNotificacion from '../scripts/notification';
import Heading from '../components/heading/Heading';
import Item from '../components/custom/Item';
import Formatter from '../scripts/formatters';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';

const DvLocation = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 8
}));

export default function Localizaciones() {
  const dispatch = useDispatch()
  const isMobile = useMediaQuery('(max-width: 740px)')
  const userLogin = JSON.parse(localStorage.getItem('user'))

  const [selectionModel, setSelectionModel] = useState()  
  const [loading, setLoading] = useState(false)
  const [dataLocations, setDataLocations] = useState([])
  const [valueFechas, setValueFechas] = useState({ fechaIni: '', fechaFin: '' })
  const [empleadoSelected, setEmpleadoSelected] = useState(null)
  const [dataEmpleados, setDataEmpleados] = useState([])

  /* Formato de fecha actual.
  const today = new Date()
  day = String(today.getDate()).padStart(2, '0')
  const month = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
  const year = today.getFullYear()
  const fechaActual = `${year}-${month}-${day}`
  */

  // Columnas de la tabla.
  const columns = [
    { 
      field: 'Consecutivo',
      headerName: 'Consecutivo',
      width: 100,
      align: 'center',
      headerAlign: 'center',
    },
    { 
      field: 'CodigoEmpleado',
      headerName: 'Cod. Empleado',
      width: 120,
      align: 'center',
      headerAlign: 'center',      
    },   
    { 
      field: 'NombreEmpleado',
      headerName: 'Nombre del Empleado',
      minWidth: 200,
      flex: 1,
    },
    {
      field: 'Fecha',
      headerName: 'Fecha registro',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: (value) => Formatter.dateTimeFormatter(value),
    },
    { 
      field: 'Longitud',
      headerName: 'Longitud',
      width: 120,
      align: 'center',
      headerAlign: 'center',      
    }, 
    { 
      field: 'Latitud',
      headerName: 'Latitud',
      width: 120,
      align: 'center',
      headerAlign: 'center',      
    },
    { 
      field: 'Dispositivo',
      headerName: 'Dispositivo',
      width: 120,
      align: 'center',
      headerAlign: 'center',      
    },
    {
      field: 'Localizacion',
      headerName: 'Localización',
      width: 100,
      headerAlign: 'center',      
      renderCell: (params) => {
        const openLinkGoogleMaps = (e) => {
          try {            
            const data = params.row
            const latitud = data.Latitud
            const longitud = data.Longitud
  
            if (!latitud || !longitud) {
              msgNotificacion('No se encontró la ubicación', 'warning')
              return
            }

             const urlGoogleMaps = `https://maps.google.com/?q=${latitud},${longitud}`
             window.open(urlGoogleMaps, '_blank')
          } catch (error) {
            console.error(error)
          }
        }
        
        return (
          <Stack direction='row' justifyContent='center'>
            <Tooltip title='Abrir en google Maps'>
              <IconButton aria-label='buscar' color='info' onClick={openLinkGoogleMaps}>
                <LocationOnIcon fontSize='medium' color='success'/>
              </IconButton>
            </Tooltip>
          </Stack>
        );
      }
    },
  ]

  const openLinkGoogleMapsMobile = (coordenadas) => {
    try {      
      const latitud = coordenadas.lat
      const longitud = coordenadas.lng

      if (!latitud || !longitud) {
        msgNotificacion('No se encontró la ubicación', 'warning')
        return
      }

      const urlGoogleMaps = `https://maps.google.com/?q=${latitud},${longitud}`
      window.open(urlGoogleMaps, '_blank')
    } catch (error) {
      console.error(error)
    }
  }

  const refreshData = () => {
    try {            
      const data = {
        codUsuario: userLogin.CodigoUsuario,
        codEmpleado: !empleadoSelected ? 'EM00000 ' : empleadoSelected.id,
        fechaIni: valueFechas.fechaIni,
        fechaFin: valueFechas.fechaFin,
      }
            
      getLocationEmployed(data)
    } catch (error) {
      console.error(error)
    }
  }
  
  const getLocationEmployed = async (data) => {
    try {
      if (!data.codEmpleado) {
        msgNotificacion('Seleccione un empleado', 'warning')
        return
      }      

      setLoading(true)

      HomeService.getLocationEmployee(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              setDataLocations(response.Data)              
            } else {
              setDataLocations([])              
              msgNotificacion(response.Mensaje, 'warning')
            }

            setLoading(false)
          }, 1000)
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
    }
  }

  const getEmpleados = async () => {
    try {
      EmpleadoService.getDatosCboSolicitud()
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }

          if (response.Codigo === 1) {
            const data = response.Data

            setDataEmpleados(data?.Empleados)
          } else {
            setDataEmpleados([])
            msgNotificacion(response.Mensaje, 'warning')
          }
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
    }
  }  

  const handleChangeEmpleado = (event, values) => {
    try {
      setEmpleadoSelected(values)

      if (!values) {        
        return
      }

    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeFechas = (event) => {
    try {
      setValueFechas({
        ...valueFechas,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  let didInit = false

  useEffect(() => {
    document.title = `Listado de Usuarios - ${NAME_PROJECT}`

    try {
      dispatch(showProgress(true))
      setTimeout(() => {

        if (!didInit) {          
          didInit = true
 
          const data = {
            codUsuario: userLogin.CodigoUsuario,
            codEmpleado: !empleadoSelected ? 'EM00000' : empleadoSelected.id,
            fechaIni: valueFechas.fechaIni,
            fechaFin: valueFechas.fechaFin,
          }
          
          getLocationEmployed(data)
          getEmpleados()
        }

        dispatch(showProgress(false))
      }, 1000) 
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <div className='App-content'>
      <Heading className='mt-0 py-0 w-100 heading justify-content-center'>
        <div className='heading-text'>
          <i className='bx bx-location-alt mx-1'></i>          
          <span>Registro de Localizaciones</span>
        </div>
      </Heading>

      <div className='row w-100 h-100'>
         <Grid container spacing={1} className='pe-0'>
          <Grid item xs={12} md={12} className='MuiList-filter'>
            <Autocomplete
              id="cboEmpleados"
              getOptionLabel={option => (option.id + ' - ' + option.label)}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              options={dataEmpleados}
              fullWidth
              className='me-2 text-transform-none cbo-empleado-home'
              value={empleadoSelected || null}
              onChange={handleChangeEmpleado}
              renderInput={(params) => <TextField {...params} label="Listado de Empleados" className='text-transform-none' />}
            />

            <TextField
              id='txtFechaInicio'
              name='fechaIni'
              type='date'
              label='Fecha inicial'
              size='small'
              fullWidth
              value={valueFechas.fechaIni}
              onChange={handleChangeFechas}
              className='text-fecha-home me-2'
              InputLabelProps={{
                shrink: true,
                className: 'LabelMui'
              }}
            />

            <TextField
              id='txtFechaFinal'
              name='fechaFin'
              type='date'
              label='Fecha final'
              size='small'
              fullWidth
              value={valueFechas.fechaFin}
              onChange={handleChangeFechas}
              className='text-fecha-home me-2'
              InputLabelProps={{
                shrink: true,
                className: 'LabelMui'
              }}
            />

            <Tooltip title='Refrescar datos'>
              <Button
                variant='contained'
                className='text-transform-none me-2'
                color='info'
                startIcon={<RestartAltIcon />}
                onClick={() => refreshData()}
                size='small'
                fullWidth
              >
                Refrescar
              </Button>
            </Tooltip>

          </Grid>

          {isMobile ? (
            loading ?
              <Grid container spacing={1} paddingX={1} textAlign='center' alignItems='center' height='50%'>
                <Grid item xs={12}>
                  <CircularProgress color='inherit' />
                </Grid>                
              </Grid>
              :
                dataLocations?.length === 0
                ?
                  <Grid container flexDirection='column' alignItems='center' justifyContent='center' height='50%'>
                    <Typography color='#fff' marginBottom={1}>No hay registro de Ubicaciones</Typography>
                    <FmdBadIcon fontSize='large' color='inherit' />
                  </Grid>
                :
                  <Grid container marginBottom='auto' justifyContent='center' alignItems='center'>
                    <Grid item xs={12} md={12}>
                      <Stack marginY={1} marginX={1}>
                        <DvLocation>
                          <List dense={true}>
                            {
                              dataLocations?.map((item) => {
                                return (
                                  <div key={item.Consecutivo}>
                                    <ListItem
                                      secondaryAction={
                                        <Tooltip title='Abrir en google Maps'>
                                          <IconButton size='large'
                                            edge="end"
                                            aria-label="location"
                                            onClick={() => openLinkGoogleMapsMobile({ lat: item.Latitud, lng: item.Longitud })}
                                          >
                                            <LocationOnIcon color='success' />
                                          </IconButton>
                                        </Tooltip>
                                      }
                                    >
                                      <ListItemAvatar>
                                        <Avatar className='bg-danger'>
                                          <AlarmOnIcon color='inherit' />
                                        </Avatar>
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={<span className='text-blue fw-bolder text-decoration-underline'><span className='fw-normal text-default'>EMPLEADO:</span> {item.CodigoEmpleado} - {item.NombreEmpleado}</span>}
                                        secondary={`Fecha marcación: ${Formatter.dateTimeFormatter(item.Fecha)}`}
                                      />
                                    </ListItem>
                                    <Divider variant='inset' component='li' />
                                  </div>
                                )
                              })
                            }
                          </List>
                        </DvLocation>
                      </Stack>
                    </Grid>
                  </Grid>
          ) : (
            <Grid item xs={12} md={12}>
              <Item className='MuiPaper-root-dataGrid'>
                <DataGrid
                  rows={dataLocations}
                  columns={columns}
                  getRowId={(row) => row?.Consecutivo}
                  pageSize={PAGE_SIZE}
                  pageSizeOptions={[5, 10, 25, 50, 100]}
                  loading={loading}
                  localeText={Formatter.localizedTextsMapColumns}
                  onRowSelectionModelChange={(selection) => {
                    if (selection.length > 1) {
                      const selectionSet = new Set(selectionModel)
                      const result = selection.filter((s) => !selectionSet.has(s))

                      setSelectionModel(result)                  
                    } else {
                      setSelectionModel(selection)                  
                    }
                  }}
                  // Ocultar la casilla de check all.
                  sx={{
                    "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                      display: "none"
                    }
                  }}
                  getRowClassName={(params) =>
                    params.row.IsBaja === true ? 'bg-default' : ''
                  }
                  rowSelectionModel={selectionModel}
                  showCellVerticalBorder
                  showColumnVerticalBorder
                  checkboxSelection
                  density='compact'
                  slots={{
                    noRowsOverlay: CustomNoRowsOlverlay
                  }}
                />
              </Item>
            </Grid>
          )
          }
         </Grid>
      </div>
    </ div>
  )

}